import {trackPromise} from "react-promise-tracker";
import {getUrl} from "../../constants/urls";
import Call from "../../service/axios";
import CallV2 from "../../service/axiosV2";

export const getDataExplorerTemplatesAsync = ({data}) => {
  const url = getUrl("dataExplorerTemplates");
  return trackPromise(CallV2.post(url, data));
};

export const getDataExplorerAnalysisAsync = ({data}, trackThisPromise = true) => {
  const url = getUrl("dataExplorerAnalysis");
  if (trackThisPromise) {
    return trackPromise(CallV2.post(url, data));
  } else {
    return CallV2.post(url, data);
  }
};

export const getDataExplorerTimezonesAsync = ({data}) => {
  const url = getUrl("dataExplorerTimezones");
  return trackPromise(Call.post(url, data));
};

export const saveDataExplorerSnapshotAsync = ({dashboard_id, data}) => {
  const url = getUrl("dashboardCells")(dashboard_id);
  return trackPromise(CallV2.post(url, data));
};

export const getDataExplorerSnapshotsAsync = (mac) => {
  const url = getUrl("dataExplorerSnapshots");
  return trackPromise(CallV2.get(url, {params: {controller_pk: mac}}));
};
